import React, { Component, useReducer } from 'react';
import {Collapse,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import StripeCheckoutt from 'react-stripe-checkout';


class StripeCheckout extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
        super(props);
        this.state = {

        };
        this.HandleChange = (e) =>{
            this.setState({[e.target.name]: e.target.value});
        };

        this.OnToken = (token) => {
            console.log(token);
            alert('Payment Succesful!');
        };
    }

    componentDidMount() {

    }




    render() {
        var price = this.props.price
        var price_for_stripe = price * 100
        var publishable_stripe_key = 'pk_live_51IvS3EFY0G8FjVy5FbVrNNUFyV3HhWL0YncX6o1FLWwOnC1Jb4w8FCOjCasqSTJ3HBtVG8m9jRtwNqsMC7mhXnxd002t5QYRGM'

        const onToken = token => {
            var origins = this.props.origins

            if (origins == 'book_session'){
                this.props.BookSession(price)
            }else if (origins == 'basic_plan'){
                this.props.PaymentSuccessful()
            }else if (origins == 'program'){
                this.props.ProgramPurchaseSuccessful(price)
            }

            console.log(token);
            alert('Payment Succesful!');
        };

        const { cookies } = this.props;
        if(cookies.get('token')==null){
            return (
                <div>
                    <Button href='/signin' style={{border: '1px solid #1faced', backgroundColor: '#ffffff', color: '#1faced', fontSize: '13px'}}>
                        Sign in to start making payments
                    </Button>
                </div>
            )
        }

        return (
            <StripeCheckoutt
                label='Pay Now'
                name='OnFit Co.'
                billingAddress
                shippingAddress
                image='https://thumbs.dreamstime.com/b/blue-gradient-logo-o-alphabet-letter-design-icon-company-suitable-as-business-logotype-166327966.jpg'
                description={`Your total is $${price}`}
                amount={price_for_stripe}
                panelLabel='Pay Now'
                token={onToken}
                stripeKey={publishable_stripe_key}
            />
        );
    }

  };
  
  export default withCookies(StripeCheckout);